import React, { useRef, useState, useContext } from "react";
//import { useNotify } from "react-admin";
import { TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import config from '../config.json';
import { stringify } from 'query-string';
import { ContextProvider } from '../globalContextProvider';
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';

export default function ParkingSearchSelector(props) {
	const { setIsChange } = useContext(ContextProvider);
	const { value, onChange, zones, label = "Parking Name", style, clearable = true, filter, routeUrl = "parkings", pathName, ...restProps } = props;
	//const notify = useNotify();
	const [parkings, setParkings] = useState([]);
	const [parkingsLoading, setParkingsLoading] = useState(false);
	const [parkingFilter, setParkingFilter] = useState("");

	const fetchParkingTimeout = useRef(null);

	const handleParkingFilterChange = (event, value) => {
		setParkingFilter(value);
	};

	const fetchParkings = () => {
		setParkingsLoading(true);
		var params = {
			user_id: sessionStorage.getItem("user_id"),
			filter: JSON.stringify({ name: parkingFilter, zones, includeSocieties: true, ...filter }),
			page: 1,
			perPage: 10
		}
		fetch(`${config.HOST_NAME}/crm/v3/${routeUrl}?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		})
			.then(response => {
				saveTokens(response)
				return response.json()
			})
			.then((responseJson) => {
				setParkingsLoading(false);
				if (responseJson.success) {
					setParkings(responseJson.data);
					setIsChange(false)
				} else {
					notify(responseJson.message, 'warning');
				}
			})
			.catch((e) => {
				notify('Error fetching Parkings', 'warning')
			});
	};

	React.useEffect(() => {
		setIsChange(false)
		if (fetchParkingTimeout.current)
			clearTimeout(fetchParkingTimeout.current);
		fetchParkingTimeout.current = setTimeout(fetchParkings, 500);
	}, [parkingFilter]);  // eslint-disable-line react-hooks/exhaustive-deps

	return <Autocomplete
		blurOnSelect
		disableClearable={!clearable}
		getOptionLabel={parking => parking ? (zones ? parking.name : parking.general_name) : ""}
		getOptionSelected={(option, value) => option.id === value.id}
		loading={parkingsLoading}
		noOptionsText="No Parkings"
		onInputChange={handleParkingFilterChange}
		options={parkings}
		renderInput={params => <TextField {...params} label={label} variant="outlined" />}
		onChange={(event, value) => {

			if (sessionStorage.getItem(pathName)) {
				let prevdata = JSON.parse(sessionStorage.getItem(pathName))
				sessionStorage.setItem(`${pathName}`, JSON.stringify({ ...prevdata, currentParking: { ...value, allZones: true } }))
			} else {
				sessionStorage.setItem(`${pathName}`, JSON.stringify({ currentParking: { ...value, allZones: true } }))
			}
			onChange(value)
			setIsChange(true)
		}}
		value={value}
		style={{ marginTop: 10, ...style }}
		{...restProps}
	/>;
}